// extracted by mini-css-extract-plugin
export default {"root":"TariffSpace__root--2UHBH","tariffSpace":"TariffSpace__tariffSpace--3mHx8","tariffUnits":"TariffSpace__tariffUnits--3MBXb"};